function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import isImageComponent from './isImageComponent';
import findAndDecorateWithProps from './findAndDecorateWithProps';
/**
 * Shared logic for passing images into media object components (e.g. Trophy, Player, ChatGroup)
 * while allowing the image to be nested one level deep to provide the flexibility to
 * composite some UI elements above the image (e.g. Tags, etc)
 * @param {Node} image possible rendered image component of type Media or Image to
 *     add component specific props too
 * @param {Object} props
 * @param {string} props.className the className to add to the image
 * @param {string} props.qa the components qa id
 * @param {string|number} props.width the width to apply to the image
 * @param {string} props.size the size to apply to the image if supported (e.g. AvatarIcon)
 * @param {Object} options
 * @param {string} options.parentClassNames classNames to apply to all parent elements, useful
 *   when needing to make sure percentage based widths are maintained
 */

function findAndDecorateImageProps(image) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 ? arguments[2] : undefined;
  return findAndDecorateWithProps(image, _objectSpread({
    aspectRatio: '1:1',
    type: 'image'
  }, props), isImageComponent, options);
}

export default findAndDecorateImageProps;